import useLanguage from '../../../hooks/useLanguage';
import { paginationElementClassName } from '../constants';
import { swiperSettings } from '../constants/config';
import useGetReadyPromotions from '../hooks/useGetReadyPromotions';
import { usePromotionClick, usePromotions } from '../hooks/useHorizontalPromotions';
import { HorizontalPromotionRenderer } from './presentation/HorizontalPromotionRenderer';

const HorizontalBanner = ({ carousel }) => {
    // Hooks and data retrieval
    const language = useLanguage();
    const { onClickHandler } = usePromotionClick();
    const { promotions: content } = useGetReadyPromotions(carousel);
    const { groupedPromotions, ppvPromotions, groupedCommon } = usePromotions({ content, onClickHandler });

    const args = swiperSettings(language);

    return (
        <HorizontalPromotionRenderer
            groupedPromotions={groupedPromotions}
            ppvPromotions={ppvPromotions}
            groupedCommon={groupedCommon}
            args={args}
            paginationElementClassName={paginationElementClassName}
            carousel={carousel}
        />
    );
};

export default HorizontalBanner;
